import { observable, set, action } from 'mobx';

export interface IProductReview {
    average_rating: number;
    number_of_questions: number;
    number_of_reviews: number;
}

export class ProductReview {
    @observable public averageRating: number;
    @observable public numberOfQuestions: number;
    @observable public numberOfReviews: number;

    public static fromJson(payload: IProductReview): ProductReview {
        const rating = new ProductReview();
        if (!payload) {
            return rating;
        }
        set(rating, payload);
        rating.averageRating = payload.average_rating
            ? parseFloat(payload.average_rating.toFixed(1))
            : 0;
        rating.numberOfQuestions = payload.number_of_questions;
        rating.numberOfReviews = payload.number_of_reviews;

        return rating;
    }

    public toJSON(): IProductReview {
        return {
            average_rating: this.averageRating,
            number_of_questions: this.numberOfQuestions,
            number_of_reviews: this.numberOfReviews
        };
    }

    @action
    public setRating = (index: number) => {
        this.numberOfReviews = this.numberOfReviews + 1;
    };
}
